module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/mysteryMemorablia-859a57bd860586570709252c2183d6ed.svg";